/**
 * Pantallas del portal (alineado con bela-belleza-api `App\Support\AppScreens`).
 */
export const APP_DEFAULT_LANDING_PATH = '/app/compras';

export const AppScreenId = {
  Dashboard: 'dashboard',
  Compras: 'compras',
  Clientes: 'clientes',
  Sorteo: 'sorteo',
  Promociones: 'promociones',
  Usuarios: 'usuarios',
} as const;

export type AppScreenIdType = (typeof AppScreenId)[keyof typeof AppScreenId];
